var DOMPurifyService = (function DOMPurifyService() {

    function init() {
        DOMPurify.setConfig({
            ALLOWED_TAGS: []
        });
    }

    return {
        init: init
    };
}());

Object.freeze(DOMPurifyService);
